<template>
  <b-modal
    :active.sync="rentalConditionsModal.value"
    scroll="keep"
    class="conditions-modal scrollbar-hide"
    :can-cancel="['escape', 'x', 'outside']"
    @close="closeModal"
    @active-change="updateModalStatus"
  >
    <div class="card">
      <div class="card-content conditions-text">
        <h2 class="price-heading">Rental conditions</h2>
        <div class="mt-24" type="is-warning">
          <b>Important to note:</b>

          Renter and all drivers of the rented vehicle, need to be a minimum age of 21
          years old and must be in possession of a valid driver’s licence that is a
          minimum of 2 years old.
        </div>
        <div v-if="rateType == 'Express Lane'" class="mt-24" type="is-warning">
          <b>Renter registration:</b> All renters must register here by clicking this
          <a href="https://zfrmz.com/lYjJXMcaEuoHPRPnbBfZ">link</a>.
        </div>
        <div class="mt-24" type="is-warning">
          <b>Please note:</b> A rental deposit of R{{ fees.fuelDepositRegular }} is taken by
          the rental agency when you collect the car and sign acceptance of the rental
          conditions. The deposit less any charges payable to the rental agency is
          refundable within 5-8 working days.
          <br> <br>
          <b>Express Lane bookings:</b> Payment must be made with the primary driver's Investec Visa card.
          <br />
          <br />Investec can only guarantee a vehicle group and not vehicle makes or
          models. We are only able to request vehicle makes or models on behalf of renters
          but this is subject to availability and at no stage guaranteed.
          <br />
          <br />Optional extras and other charges are deducted from the rental deposit eight
          working days' post return of the car.
        </div>
        <div class="mt-24">
          <b>
            Should the vehicle be damaged, the following will be charged 15 working days'
            post return of the car:
          </b>

          <ul class="mt-24">
            <li>Claims administration fee</li>
            <li>Excess</li>
            <li>Assessment fee</li>
          </ul>
        </div>
        <div class="mt-24">
          <b>
            Please note that fines can take up to 12 months to be redirected to you, in
            which you will be responsible for full settlement of:
          </b>

          <ul class="mt-24">
            <li>Traffic fines</li>
            <li>
              Traffic fine administration fee (charged per fine) of R{{
                fees.trafficFineAdminFee
              }}
              is charged in addition to the actual fine amount, in order to cover the cost
              of redirecting the fine to you.
            </li>
          </ul>
        </div>
        <div class="mt-24">
          <b>Extension of rental</b>

          <ul class="mt-24">
            <li>
              Rentals not returned by the stipulated date and time of the rental
              agreement, where the rental becomes overdue, the renter will be liable for
              additional overdue fees as well as the extra day’s charge. Damages or theft
              will not be covered by the selected waivers resulting in the renter being in
              breach of contract and liable for the full replacement value.
            </li>
            <li>
              Renter’s must contact Investec Travel to arrange an extension on the rental
              should they wish to extend the vehicle hire. Only once the renter receives
              confirmation from Investec Travel that the extension request has been
              authorised, may the vehicle be returned on the newly agreed date and time.
              Investec Travel must be contacted again should further extensions be
              required.
            </li>
          </ul>
        </div>
        <div class="mt-24">
          <b> Cancellation Policy</b>
          <ul class="mt-24">
            Reservations are subject to cancellation, and or no-show fees:
            <br /><br />
            <li>
              Cancellation fee of R{{ fees.cancellationPenaltyWithin24Hr }} applies if cancelled 24
              hours prior to pick up.
            </li>
            <li>No show fee of 1 day rental charge + R{{ fees.noShowPenalty }}.</li>
          </ul>

          <br />
          <b> During peak season 07 December – 10 January: </b>

          <ul class="mt-24">
            <li>
              If cancelled within 7days from pick up, 50% fee cancellation fee, with
              minimum R{{ fees.cancellationPenaltyWithin24Hr }} if amount is lesser.
            </li>
            <li>
              Within 24 hours of pick up, 100% cancellation fee, with minimum R{{
                fees.cancellationPenaltyWithin24Hr
              }}
              if amount is lesser.
            </li>
          </ul>
        </div>
        <div class="mt-24">
          <b>Changes to booking</b>
        </div>
        <div class="mt-24">
          <ul>
            <li>
              Changes and amendment fees may apply and vary depending on availability at
              time of making the change as well as the individual conditions that will be
              presented at time of booking
            </li>
            <li>
              Overdue penalty: This is only applicable where there has been no prior
              arrangements made for rental extension ahead of rental expiry date and time.
            </li>
            <li>
              No show penalty: 1 day rental + R{{ fees.noShowPenalty }} per rental. This
              is only applicable where there has been no prior arrangements made to cancel
              the booking ahead of the rental date and time.
            </li>
            <li>
              All theft and accidents even if no other vehicle involved, must be reported
              to the car rental company and the South African Police Service within 24
              hours of the incident occurring. The S.A.P.S case number must be supplied to
              the car rental company when completing the claim form.
            </li>
          </ul>
        </div>
        <div class="mt-24">
          <b>Express Lane rental conditions/ mandatory:</b>
          <ul class="mt-24">
            <li>All renters must register using the following link: <a href="https://zfrmz.com/lYjJXMcaEuoHPRPnbBfZ">https://zfrmz.com/lYjJXMcaEuoHPRPnbBfZ</a></li>
            <li>Express Lane service will be available at OR Tambo, King Shaka, and Cape Town International Airport.</li>
            <li>The rental terms and conditions with the suppliers' rental agreement must be accepted.</li>
            <li>Acceptance will mean that you have read and understood the conditions.</li>
            <li>Only Super Cover will be offered.</li>
            <li>Tyre and Glass protection included in the daily rate.</li>
            <li>Offline reservations: R{{ fees.afterHoursOffLineFee }} fee will be charged for all offline reservations after 17h00 until 08h00 the next morning. (After Hours and public holiday's).</li>
            <li>Online reservations: Free of handling fee.</li>
            <li>The Express Lane option is valid for Investec credit card holders only.</li>
            <li>Confirmed and paid rentals cancelled will be subject to a R{{ fees.cancellationPenalty }} cancellation fee.</li>
            <li>The excess deposit will be refunded within 48 hours after termination providing no damage or fines).</li>
            <li>Cancellation fee: R{{ fees.cancellationPenaltyWithin24Hr }} fee will be applicable for all rentals cancelled 24 hours prior to pick up.</li>
            <li>Express Lane benefit will be applicable at Bluu car rental only.</li>
            <li>The rental amount will be taken at the time of confirmation.</li>
            <li>Rental Deposit and the excess amount will be taken 48 hours prior to pick up.</li>
          </ul>
        </div>
        <div class="modal-divider"></div>
        <div class="modal-close-container">
          <div @click="closeModal" class="close-button">Close</div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { FeesData } from "@/services/Fees.js";

export default {
  name: "rentalConditionsModal",
  props: {
    rentalConditionsModal: {
      type: Object,
      default: () => ({ key: null, value: false }),
    },
    currentIndex: Number,
    rateType: String,
  },
  computed: {
    fees() {
      return FeesData;
    },
  },
  methods: {
    closeModal() {
      this.$emit("update:rentalConditionsModal", {
        key: this.currentIndex,
        value: false,
      });
    },
    updateModalStatus() {
      this.$emit("update:rentalConditionsModal", {
        key: this.currentIndex,
        value: false,
      });
    },
  },
};
</script>
